import React from 'react';
import PropTypes from 'prop-types';

import { Image } from '$partials/media';
import { useLocale } from '$contexts/locale.jsx';

const defaultImage = {
    src: '/images/default-x1.jpg',
    x2: '/images/default-x2.jpg',
};

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const ArticleStandardListingItem = ({
    activities,
    listingFields,
    partnership,
    partnershipLogo,
    slug,
    title
}) => {
    const { formatURI } = useLocale();

    return (
        <a
            className='w-full'
            href={formatURI(`/articles/${slug}`)}>
            <figure className='w-full relative'>

                {partnershipLogo && (
                    <div className='h-[70px] w-[70px] sm:w-[80px] sm:h-[80px] absolute -top-[35px] sm:-top-[40px] right-10 sm:right-20 z-50'>
                        <div
                            className='bg-cover rounded-full overflow-hidden w-full h-full bg-white flex items-center px-10'>
                            <img
                                src={partnershipLogo?.src} />
                        </div>
                    </div>
                )}

                <Image {...(listingFields?.listingImage || defaultImage)} />
            </figure>

            {activities.items.length > 0 && (
                <div className='flex items-center mt-20'>
                    {activities.items[0]?.icon && (
                        <div className='mr-5'>
                            <img
                                alt={activities.items[0].icon.alt}
                                className='pointer-events-none'
                                height='23'
                                loading='lazy'
                                role='presentation'
                                src={activities.items[0].icon.src}
                                width='23' />
                        </div>
                    )}

                    <p className='text-orange type-style-7 '>{activities.items[0]?.title}</p>
                </div>
            )}

            <h3 className='type-style-4 mt-20'>
                {title}
            </h3>

            {listingFields?.listingText && (
                <div className='mt-10 type-style-8 text-dark-grey'>
                    {listingFields.listingText}
                </div>
            )}

            {/* {partnership && (
                <p className=' type-style-7 mt-30'>
                    Paid Partnership
                </p>
            )} */}
            {partnership && (
                <div className='flex flex-col sm:flex-row gap-5 mt-20'>
                    <p className=' type-style-7 bg-peach text-black p-10 w-max'>
                        STRAVA | {partnership}
                    </p>
                    <p className='type-style-7  bg-peach text-black p-10 w-max'>
                        Sponsored article
                    </p>
                </div>
            )}
        </a>
    );
};

/* =========================================================================  */
/* Typing and export(s) */
/* =========================================================================  */

const propTypes = {
    listingFields: PropTypes.shape({
        listingImage: PropTypes.object,
        listingText: PropTypes.string,
    }),
    partnership: PropTypes.string,
    partnershipLogo: PropTypes.object,
    slug: PropTypes.string,
    activities: PropTypes.shape({
        items: PropTypes.array,
    }),
    title: PropTypes.string,
};

ArticleStandardListingItem.propTypes = propTypes;

export default ArticleStandardListingItem;
